import * as Scrivito from "scrivito";
import defaultSocialHeaderButtonAttributes from "../_defaultSocialHeaderButtonAttributes";

const FacebookSocialHeaderButton = Scrivito.provideObjClass(
  "FacebookSocialHeaderButton",
  defaultSocialHeaderButtonAttributes,
);

export default FacebookSocialHeaderButton;
